module.exports = require("./de-DE");